import secureLocalStorage from "react-secure-storage";
import React, { Component } from "react";
import Images from "../Assets/Images";
import "../Styles/Login.scss";
import { toastr } from "react-redux-toastr";
import Api from "../Services/Api";
import CircularProgress from "@material-ui/core/CircularProgress";
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
export default class ChangePassword extends Component {
  constructor(props) {
    super(props);
    this.state = {
      oldPassWord: "",
      newPassword: "",
      confirmNewPassWord: "",
      loader: false,
      OldPasswordVisibility:false,
      NewPasswordVisibility:false,
      confirmPasswordVisibility:false,
    };
  }

  componentDidMount() {
    this.isAuthorizeUse();
  }
  isAuthorizeUse = () => {
    if (!secureLocalStorage.getItem("authToken")) {
      if (this.props.match.params.id) {
        this.props.history.push({
          pathname: `/tenant/${this.props.match.params.id}`,
        });
      } else {
        this.props.history.push({
          pathname: "/",
        });
      }
    }
  };

  handleOldPassword = (e) => {
    this.setState({
      oldPassWord: e.target.value,
    });
  };

  handleNewPassword = (e) => {
    this.setState({
      newPassword: e.target.value,
    });
  };

  handleCOnfirmNewPassword = (e) => {
    this.setState({
      confirmNewPassWord: e.target.value,
    });
  };

  CheckPassword = (inputtxt) => {
    var paswd = /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{7,15}$/;
    if (inputtxt.match(paswd)) {
      return true;
    } else {
      return false;
    }
  };

  cancelChangePassword = (event) => {
    event.preventDefault();
    let tenantKey = secureLocalStorage.getItem("tenantKey");
    let loggedClient = secureLocalStorage.getItem("loggedClient");
    secureLocalStorage.setItem("ActivePage", "Home");
    if (loggedClient != "user") {
      this.props.history.push(`/tenant/${tenantKey}/home/main`);
    } else if (loggedClient === "user") {
      let userKey = secureLocalStorage.getItem("userKey");
      if (userKey) {
        this.props.history.push(`/user/${userKey}/home/main`);
      } else {
        this.props.history.push(`/`);
      }
    }
  };
  // redirect login page
  redirectHomePage() {
    let tenantKey = secureLocalStorage.getItem("tenantKey");
    let loggedClient = secureLocalStorage.getItem("loggedClient");
    secureLocalStorage.setItem("ActivePage", "Home");
    if (loggedClient != "user") {
      this.props.history.push(`/tenant/${tenantKey}/home/main`);
    } else if (loggedClient === "user") {
      let userKey = secureLocalStorage.getItem("userKey");
      if (userKey) {
        this.props.history.push(`/user/${userKey}/home/main`);
      } else {
        this.props.history.push(`/`);
      }
    }
  }

  handleSubmit = async (e) => {
    e.preventDefault();
    this.setState({
      loader: true,
    });
    let email = secureLocalStorage.getItem("setEmail");
    let { oldPassWord, newPassword, confirmNewPassWord } = this.state;
    if (oldPassWord != "" && newPassword != "" && confirmNewPassWord != "") {
      if (
        this.CheckPassword(newPassword) &&
        this.CheckPassword(confirmNewPassWord)
      ) {
        if(newPassword!=confirmNewPassWord){
          this.setState({
            loader: false,
          });
          toastr.error("New password and confirm password are not same");
          return;
        }
        if (oldPassWord != newPassword) {
          let params = {
            oldPassword: this.state.oldPassWord,
            password: this.state.newPassword,
            tenantKey: this.props.match.params.id,
            tenantemail: email,
          };

          let result =await Api.changePassword(params);
          this.setState({
            loader: false,
          });
          if (result.status === 200) {
            this.setState({
              oldPassWord: "",
              newPassword: "",
              confirmNewPassWord: "",
            });
            toastr.success(result.message);
            this.redirectHomePage();
          } else {
            this.setState({
              loader: false,
            });
            toastr.error(result.message);
          }
        } else {
          this.setState({
            loader: false,
          });
          toastr.error("make sure password was different");
        }
      } else {
        this.setState({
          newPassword: "",
          confirmNewPassWord: "",
          loader: false,
        });
        toastr.error(
          "A password between 8 to 15 characters which contain at least one lowercase letter, one uppercase letter, one numeric digit, and one special character"
        );
      }
    } else {
      this.setState({
        loader: false,
      });
      toastr.error("fields should not be empty");
    }
  };

  render() {
    console.log("-----------")
    return (
      <div className="auth-wrapper">
        <div className="auth-inner">
          <div className="authCont">
            <div className="logo">
              <img src={Images.RISKWELLLOGO} alt="Logo" width="200" />
            </div>
            <form name="form">
              <h4>Change Password</h4>
              {/* <div className="form-group">
                           <div className="ip-field">
                               <input type="email" name ="email"  placeholder="Email Address" className="form-control"  />
                               <span>
                                   <img src={Images.MAIL} alt="Mail" width="17"/>
                               </span>
                           </div>
                   </div> */}
              <div className="form-group">
                <div className="ip-field1">
                  <input
                    value={this.state.oldPassWord}
                    onChange={(e) => {
                      this.handleOldPassword(e);
                    }}
                    type={this.state.OldPasswordVisibility==true ?"text":"password"}
                    name="password"
                    placeholder="Old Password"
                    className="form-control"
                    autocomplete="off"
                  />
                  
                  <span style={{width:"17px"}}>
                    <img src={Images.PASSWORD} alt="User" width="17px" />
                  </span>
                  <span  style={{display:"inline-block",right:"5px",position:"absolute"}}
                  onClick={()=>this.setState({OldPasswordVisibility:!this.state.OldPasswordVisibility})}>
                    {
                      this.state.OldPasswordVisibility?<VisibilityOutlinedIcon htmlColor="#005f62"/>:<VisibilityOffOutlinedIcon htmlColor="#005f62"/>
                    }
                  </span>
                </div>
              </div>
              <div className="form-group">
                <div className="ip-field1">
                  <input
                    value={this.state.newPassword}
                    onChange={(e) => {
                      this.handleNewPassword(e);
                    }}
                    type={this.state.NewPasswordVisibility==true ?"text":"password"}
                    name="password"
                    placeholder="New Password"
                    className="form-control"
                    pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,32}"
                    autocomplete="off"
                  />
                  <span style={{width:"17px"}}>
                    <img src={Images.PASSWORD} alt="User" width="17px" />
                  </span>
                  <span  style={{display:"inline-block",right:"5px",position:"absolute"}}
                  onClick={()=>this.setState({NewPasswordVisibility:!this.state.NewPasswordVisibility})}>
                    {
                      this.state.NewPasswordVisibility?<VisibilityOutlinedIcon htmlColor="#005f62"/>:<VisibilityOffOutlinedIcon htmlColor="#005f62"/>
                    }
                  </span>
                </div>
              </div>
              <div className="form-group">
                <div className="ip-field1">
                  <input
                    value={this.state.confirmNewPassWord}
                    onChange={(e) => {
                      this.handleCOnfirmNewPassword(e);
                    }}
                    type={this.state.confirmPasswordVisibility==true ?"text":"password"}
                    name="confirmPassword"
                    placeholder="Confirm Password"
                    className="form-control"
                    pattern="(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,32}"
                    autocomplete="off"
                  />
                  <span style={{width:"17px"}}>
                    <img src={Images.PASSWORD} alt="User" width="17px" />
                  </span>
                  <span  style={{display:"inline-block",right:"5px",position:"absolute"}}
                  onClick={()=>this.setState({confirmPasswordVisibility:!this.state.confirmPasswordVisibility})}>
                    {
                      this.state.confirmPasswordVisibility?<VisibilityOutlinedIcon htmlColor="#005f62"/>:<VisibilityOffOutlinedIcon htmlColor="#005f62"/>
                    }
                  </span>
                </div>
              </div>
              <button
                type="submit"
                className="btn btn-primary btn-block btn-rounded relPosition"
                onClick={(e) => {
                  this.handleSubmit(e);
                }}
              >
                Submit
                {/* SPINNER */}
                {this.state.loader ? (
                  <span className="MatBtnSpinner">
                    <CircularProgress style={{ color: "#FFFFFF" }} size={22} />
                  </span>
                ) : null}
              </button>
              <button
                type="button"
                onClick={(e) => {
                  this.cancelChangePassword(e);
                }}
                className="btn btn-primary btn-transparent"
              >
                Cancel
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}
